// React things
import { useEffect, useRef, useState } from 'react';

// Styles
import style from './LeaderSection.module.css'

// Stores
import useApplicationSettings from '../../Store/ApplicationSettings.js'

// Components
import RiveArtboard from '../../ComponentsWrappers/RiveArtboard.jsx';

export default function LeaderSection(props){

    const localization = useApplicationSettings((state)=> state.localization)

    return(
        <RiveArtboard artboard={localization["rive_leader 2"]} stateMachines={'State Machine 1'} setLoading={props.setLoading}/>
    )
}